import jwtAxios from "@richbeauty/services/auth/jwt-auth/jwt-api";
import { URL_API } from "@richbeauty/services/endpoint";
import useSWRMutation from "swr/mutation";

const createTask = async (data) => {
  return jwtAxios.post(URL_API.CMS_TASKS.POST_TASK, data);
};

const useCreateTask = () => {
  const fetcher = (url, { arg }) => createTask(arg);
  return useSWRMutation(URL_API.CMS_TASKS.POST_TASK, fetcher);
};

export default useCreateTask;
